export default () => ({
    searchingData: {
        per_page: 10,
        page: 1,
        search: {
            tenant_name: '',
            tenant_group_name: ''
        },
        sort:
        {
            key: 'id',
            asc: true
        }
    },
    selectedTenant: [],
    defaultParam: {
        daily: {
            date_start: null,
            date_end: null
        },
        hourly: {
            datetime_start: null,
            datetime_end: null
        },
    },
});
